import { render } from "./NewDistributor.vue?vue&type=template&id=68817774"
import script from "./NewDistributor.vue?vue&type=script&lang=js"
export * from "./NewDistributor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__